import React from 'react';
import { Form } from '@themesberg/react-bootstrap';
import { useTranslation } from "react-i18next";

const AddressSearchCell = ({ claim, setAddressSearch, addressSearch }) => {
  const { t } = useTranslation();

  return (
    <td>
      <div className="d-flex align-items-center">
        <Form.Control
          type="number"
          value={addressSearch[claim._id] || ""}
           disabled={claim.status !== "Waiting for Admin Action"}
          onChange={(e) => {
            const value = e.target.value;
            setAddressSearch(prev => ({
              ...prev,
              [claim._id]: value
            }));
          }}
          className="modern-input"
          placeholder={t("EnterValue")}
        />
      </div>
    </td>
  );
};

export default AddressSearchCell;
